export type ParsedDistance = number | null | undefined;

const MAX_TOTAL_INCHES = 100 * 12;

export function formatDistance(totalInches: number | null | undefined): string {
  if (
    totalInches === null
    || totalInches === undefined
    || !Number.isInteger(totalInches)
    || totalInches < 0
    || totalInches >= MAX_TOTAL_INCHES
  ) {
    return "";
  }

  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  return `${feet}'${inches}"`;
}

export function parseDistance(value: string): ParsedDistance {
  const input = value.trim();
  if (!input) return null;

  const inchesOnly = input.match(/^(\d+)\s*"$/);
  if (inchesOnly) return validTotalInches(Number(inchesOnly[1]));

  const feetWithQuote = input.match(/^(\d+)\s*'\s*(\d+)?\s*"?$/);
  if (feetWithQuote) {
    return toTotalInches(feetWithQuote[1], feetWithQuote[2]);
  }

  const feetAndInches = input.match(/^(\d+)\s*(?:\.|\s)\s*(\d+)\s*"?$/);
  if (feetAndInches) {
    return toTotalInches(feetAndInches[1], feetAndInches[2]);
  }

  const feetOnly = input.match(/^\d+$/);
  return feetOnly ? validTotalInches(Number(input) * 12) : undefined;
}

function toTotalInches(feetValue: string, inchesValue?: string): number | undefined {
  const inches = inchesValue ? Number(inchesValue) : 0;
  if (inches > 12) return undefined;

  return validTotalInches(Number(feetValue) * 12 + inches);
}

function validTotalInches(totalInches: number): number | undefined {
  return totalInches >= 0 && totalInches < MAX_TOTAL_INCHES ? totalInches : undefined;
}
